type SetList = {
  title: string;
  artist: string;
  text: string;
  lyric: string;
};

export const setList: SetList[] = [
  {
    title: "はじまりのうた",
    artist: "吉田雪乃",
    text: "去年のライブでプロローグ＆エピローグのようなものをつけたくて作った曲。スネアドラムの音が作った時から鳴っていたので、杉崎さんのDrが最高によいので聴いてください！何気なくつくった曲でしたが、未来の自分に向けたような歌詞が今でも胸におきながら歌ってます。",
    lyric:
      "ぼんやり 思い出すのは\n夢か現実かわからない 朧げな記憶\n森の中 歩いていると\nどこからとなく聞こえてきた優しげなうた\n\n「これからはじまるこのうたは 君の力になるだろう\nこのうたと共にたくさんの物語を紡ぎ出して」\n\nこの先きっと見たこともない景色がずっと広がるだろう\nそこで聞こえるうたを大事に抱え集めて進んでいく\n\nうたを集めて進んでく",
  },

  {
    title: "Lemon Tree",
    artist: "Fool's Garden",
    text: "ドイツのバンドFool's Gardenの '90年代のPOPS。1回聞いただけで頭から離れなくなるリズムとなんとも言えない哀しめな曲調＆歌詞がとても好きでカバーしたくなりました。",
    lyric:
      "全文載せられないので…\n訳した好きな箇所をご紹介します。\n\n「昨日君は僕に青い空について語っていた\n僕の目に映るものは黄色いレモンの木だけだ」\n\n気になる方は調べてみてください！",
  },
  {
    title: "Calling You (手嶌葵ver.)",
    artist: "Jevetta Steele",
    text: "映画「バグダッド・カフェ」の主題歌。映画まだ見たことないんですが…笑 手嶌葵さんがカバーアルバムをいくつか出していて、そのアルバムを聴いていたら流れてきた曲です。本家Jevetta Steeleはかなりパワフルでそれはそれで素敵です。",
    lyric:
      "全文載せられないので…\n訳した好きな箇所をご紹介します。\n\n「壊れ掛けのコーヒーマシーン」\n\n情景が絶妙な感じが笑\n気になる方は調べてみてください！",
  },
  {
    title: "追想",
    artist: "吉田雪乃",
    text: "去年2番目に作った曲。そして、我ながらとても素直にまっすぐ書いたなぁという歌詞。暗い曲ですが、ちょっとくらいはみんな抱えているような黒い部分なのかなと思ってます。そして、イメージ通りの最高なバンドがもう、たまらんので合わせて聴いてみてください。音量注意です。",
    lyric:
      "ゆらゆらとこのまま 流されていたいわ\n真っ暗な気持ちを 後ろに隠して\nばらばらと散ってく 気持ちの行き場は\nまだ見つからないまま\n\nああ 嫌なことばっか見つけてしまうの\nああ まだ このまま居たくて 痛くて\n暗く染めてしまうの\n\nひたひたに浸けられた水の中では\n自由な温もりを感じていたいの\nぎらぎらな輝きを遠くに眺めて\n目を瞑って動けないまま\n\nああ まだ 心に宿った濁った記憶が\nああ まだ “今”を汚して 縛って\n固く閉じてしまうの\n\n取り繕って笑顔重ね 楽しさがわからなくって\n知らないふりを続けても 気になって仕方なくて\n正解だけを探し続け “正しさ”で固めてく\nそれらを全て捨て去っても\n\nああ 今 心に灯った光のかけらが\nああ 立ち向かう勇気の糧になるはずだから\n\nああ まだ見えない明日を目指して\nああ この先も もがいてあがいて進んでいくの",
  },
  {
    title: "たしかな。",
    artist: "吉田雪乃",
    text: "ライブタイトルと同じ名前の曲、作ってみました。「たしかな〇〇」の〇〇が思いつかなくて曖昧になっているのですが…「存在」「意味」「軌跡」などそんなニュアンスの意味合い。きっと嫌なことがあっても頑張りすぎてしまうようなことがあってもそんな全てを容認できたらという祈りです。",
    lyric:
      "どっぷり浸かる真夜中に\n1日の記憶が押し寄せる\nできることなら忘れられたいと\n破れそうな声を抑えてる\n\nどこまでも遠くて どこまでも近くて\nたしかに「在る」そんなもの\n\nきっとどこかに忘れられたら\n僕はこのまま何になれるだろう？\n「いつかいつかは」と願っては\nその「いつか」はいつ来るのだろう\n\n虚勢を張るそんな日々を\n疲れたとも思わず歩いてる\nここしか道がないからと\n他に何も見えず進んでた\n\n誰かを拒んでは離れるのが怖くて\n積み重ねた嘘の山はずっとそこに「在る」\n\n「1人で抱えられるほど僕は強くない」\n僕の中の「ぼく」がそう叫んでる\n「1人で抱えられるほど僕らは強くない」\n君の中の「きみ」もそう叫んでる\n\n作り上げたものがいつか\n「ぼく」自身だと気づいたなら\nヒトは誰しもが不完全で\n人間味溢れた 愛しいほどに",
  },
  {
    title: "いつかの想い出に似た景色",
    artist: "吉田雪乃",
    text: "今日のセットリストで唯一の恋愛もの。自分の経験からとかいうととても恥ずかしいのだけど想い出のそんな曲です。\nそしてオリジナル曲のなかでこれでも一番テンポが早い、POPSって感じの曲です。この曲の松ヶ谷さんのベース好きです。",
    lyric:
      "初めて君に出会ったとき\n僕はパッとしないやつで\n目立つやつじゃなかったし\n覚えられてたかなぁ\n恋には疎くて\n僕には無理って諦めてた\n\nでも何かいつもと違ったんだ\nこれで終わりにしたくない\nなんでだろ？ なんだこれ？ 止まらないな\n\nあのとき勇気を出して聞いたLINE\n終わりにしたくなかったから\n必死に繋ぎ止めてたんだ\nもしかしたら気づいてたかなぁ\n変なやつって思ったかなぁ\nでもいいんだ 嬉しかったから\nあの日々が懐かしいや\n\n違和感があったのは\n会う回数が減った時\n心の距離もちょっとずつ\n離れていっていたのかな\n\nでも僕は気づかなかったんだ\nいや気づきたくなかった\nだってまだ だってまだ そばにいさせてよ\n\n一緒に2人のりで自転車で駆けた\nあの道は桜が咲いていた\nふざけ合って笑い合っていたよね\nテイクアウトのピザ大きくて\n食べ切れるかなぁなんて話して\n楽しすぎてばかだったよなぁ\nあの日々がもう遠いや\n\nちょっとだけ ちょっとだけ 伝えさせて\n\nあのとき君が僕に向けた笑顔は\n僕の胸にひどく刺さった\n全部僕が悪かったのに\n不安になってしまったんだ\n君を試してしまったんだ\n勝手で本当 ばかだよなぁ\n\n長い月日を過ごしたこと\nかけがえのない時間たちは\n忘れたくない宝物で\nこの先もずっと照らしていくんだ\n僕の中で踊っていくんだ\nそれなら許してくれるかなぁ\nあの日々が愛しいな",
  },
  {
    title: "Pascal",
    artist: "aqua timez",
    text: "たぶん、ギター始めて初めて人前で演奏した曲。初めて演奏する割には暗いですね…笑 Aqua Timezは全曲知ってるほど好きで、どの曲も最高だけどこの曲も歌詞が最高です。弾き語り、頑張ります。お楽しみください。",
    lyric:
      "全文載せられないので…\n好きな箇所をご紹介引用します。\n\n「優しさとはさりげない\n気付かぬまま僕はまた人を恨む」\n\n気になる方は調べてみてください！",
  },
  {
    title: "間色",
    artist: "吉田雪乃",
    text: "「あわいろ」って読みます。ゲームや夢の世界と現実の世界の狭間のようなことをイメージしたい曲。サビは結構前にできてたのに完成まで時間がかかった…結構単純な曲なのに。笑 さっぱりすっきりしっとりと、松下さんと二人でお届けします。",
    lyric:
      "おはよう世界\n空が穏やかにうたう\n僕の心は曇ってるのに\n\nおはよう世界\n君は楽しそうだな\n何も考えてないふりして\n\n泣いて 笑って 転んで 起きて\nそんな繰り返しだな\n\nきっときっと大丈夫\n空が見守っている\nずっとずっと夢に見た\n眩いほどの光\n\nおやすみ世界\n寝静まる湿った空気に\n僕の心を委ねてみる\n\nおやすみ世界\n冷たいふりをしないでよ\n巡り巡る片隅で\n\n疲れて 眠っても 明日はやってくるの\nそんな繰り返しだな\n\nきっときっと大丈夫\n空が見守っている\nずっとずっと夢に見た\n眩いほどの光\n\n儚く 残酷な 現実に思い馳せて\nそんな繰り返しだな\n\nずっとずっと考えてる\nこの世界の続く先\nいつかいつか届くかな\n君のその温もりに",
  },
  {
    title: "漂",
    artist: "吉田雪乃",
    text: "初めて自分一人でコードをつけた曲。ふと周りと比べて自分の時間の感覚がわからなくなって、そんな時に書いた曲です。ひたすらに漂いたいイメージしかなくて、テンポも完成形も不確定な状態からバンドメンバーさんたちに素敵にしてもらいました。",
    lyric:
      "いつもの道が寂しすぎて\nどうでもいいような話をする\n言葉にできない感情の霧\nひとつひとつを噛み締めて\n\n気持ちの行き場を整理する\n\nきっとまだ日常の流れに乗れないだけ\n好きも嫌いもすべて中に隠して\n感じないように感じないように押し殺す\n今が終わらないでと願ってる\n\n素直になること苦手になって\nどこかに置いてきたんだろな\n寂しさも悲しさも楽しさも愛しさも\n全部大事なものなのに\n\n“自分”を見るのが怖いんだ\n\nきっとまだやれるはずだとどこかで願ってる\n終わりの音を聞きたくなくて\n寂しいけど寂しさはまだ感じたくないから\n楽しい余韻にまだ浸らせて\n\nやり残したことがあるんだ\nわかっているんでしょ？\nやりたい気持ちがここにあるんだ\nきづいているでしょ？\nでも でも まだ言い訳を重ねている\n\nきっとこの世界は美しさで溢れていて\n見え方次第で変わっていくんだ\n当たり前の顔をして痛みはやってくるけど\nここで終わりにしたくない\n\nきっとまだ日常の流れに乗れないだけ\n好きも嫌いもすべて中に隠して\n感じないように感じないように押し殺す\n今が終わらないでと願ってる",
  },
  {
    title: "勇気100%",
    artist: "光GENJI",
    text: "お待たせしました、やっと皆さんお馴染みの曲。唯一かもしれない…笑 実家に帰った時に、小学生のとき朝の会や音楽の時間に使っていたボロボロの「みんなのうた」が出てきて、その中で見つけた曲。光GENJIが歌っていたことも、こんなに歌詞が熱々なことも初めて知りました。とは言っても、元気100%な感じではなくて、今回のバンドらしくアレンジしているのでお楽しみに！",
    lyric:
      "全文載せられないので…\n好きな箇所をご紹介します。\n\n「さあ飛び込むしかないさ\nまだ涙だけで終わる ときじゃないだろう」\n\n気になる方は調べてみてください！",
  },
  {
    title: "幽かな陽",
    artist: "吉田雪乃",
    text: "最後と言ったらこの曲だろうなという曲。「かすかなひ」と読みます。去年時点でのありがとうの感謝を伝えたい意味を込めて作って、そこから少し変えて、より素敵になりました。リハの時「キーボードってそんな音が出るんですね」とびっくりしたので、松下さんのキーボードにも注目です。",
    lyric:
      "はしゃいでる陽の光を浴びて\n遅めの朝に目が覚める\n顔出した花と笑い合って 1日が始まる\n\nたくさんの命が混じり合い\n遠くで空が眺めてる\nそんな穏やかな日を想って\n今日もいい日だったと1日を終えるの\n\nはるか昔のこと 生まれてきた日のこと\n喜びも悲しみも望んで来たんだろう\n気づかないくらいの当たり前の中で\n僕は哀を知った\n\n新しい出会いの裏側に\nいくつも別れを繰り返す\nそんな儚い日を思い出して\n今日もいい日だったと1日を終えるの\n\nはるか昔のこと 生まれてきた日のこと\n愛しさも寂しさも望んで来たんだろう\n家族や友達や恋人ができて\n僕は愛を知った\n\nここまで来れたのは 誰かの繋がりで\n気づけば周りにたくさんの人がいた\n\n何気ない日常に散らばる光たちを\n無意識に大切に集めてきたんだ\nここまでの道のりは1人じゃないから\n僕は\n\nはるか昔のこと 生まれてきた日のこと\n喜びも悲しみも望んで来たんだろう\n気づかないくらいの当たり前の中で\n僕は愛を知った\n\n僕は愛を知った ",
  },
];
